import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { AddBillApi } from "../../../../Api/Operations/WorkOrders";
import ActionButton from "../../../Common/ActionButton";
import { getPopulateUsers } from "../../../../Redux/actions/accountsactions/getContractComments";

export default function AddBillModal({ isOpen, onClose, woData, onSuccess }) {
  const dispatch = useDispatch();
  const populateUsers = useSelector((s) => s.getAllPopulateUsers?.data || []);
  const dropdownRef = useRef(null);
  // This modal always opens against one specific WO — use its own project, not
  // whatever's active in the top nav. Old:
  // const { session } = useSession();
  // const projectId = session?.ProjectId;
  const projectId = woData?.ProjectId;

  const [cumulativePercentage, setCumulativePercentage] = useState("");
  const [image, setImage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showApproverDropdown, setShowApproverDropdown] = useState(false);
  const [approverUserIds, setApproverUserIds] = useState([]);
  const [approverSearchTerm, setApproverSearchTerm] = useState("");

  const allUsers = [
    ...populateUsers,
    // {
    //   Id: session?.LoginId,
    //   FullName: session?.UserName,
    //   Email: session?.Email,
    // },
  ];

  const filteredUsers = allUsers?.filter(
    (user) =>
      user?.FullName?.toLowerCase().includes(approverSearchTerm.toLowerCase()) ||
      user?.Email?.toLowerCase().includes(approverSearchTerm.toLowerCase()) ||
      user?.Id?.toLowerCase().includes(approverSearchTerm.toLowerCase()),
  );

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    dispatch(getPopulateUsers(projectId));
  }, [isOpen, dispatch, projectId]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowApproverDropdown(false);
      }
    }
    if (showApproverDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showApproverDropdown]);

  if (!isOpen) {
    return null;
  }

  function removeApprover(userId) {
    setApproverUserIds((prev) => prev.filter((id) => id !== userId));
  }

  function toggleApprover(userId) {
    setApproverUserIds((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId],
    );
  }

  const validate = () => {
    if (!cumulativePercentage || Number(cumulativePercentage) <= 0) {
      toast.info("Cumulative Percentage is required and must be greater than 0");
      return false;
    }
    if (Number(cumulativePercentage) > 100) {
      toast.info("Cumulative Percentage cannot exceed 100");
      return false;
    }
    // if (approverUserIds.length === 0) {
    //   toast.info("Please select at least one approver");
    //   return false;
    // }
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }
    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("workOrderId", woData?.Id || "");
      formData.append("cumulativePercentage", Number(cumulativePercentage));
      if (image) {
        formData.append("image", image);
      }
      // Append each approver ID individually for FormData array support
      approverUserIds.forEach((id, index) => {
        formData.append(`ApproverUserIds[${index}]`, id);
      });

      const res = await AddBillApi(formData);
      const json = res?.data || res;
      if (json?.IsSuccess) {
        toast.success(json.Message || "Bill created successfully");
        onSuccess?.();
      } else {
        toast.error(json?.Message || "Failed to create bill");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error creating bill");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modalscreen" style={{ display: "block", height: "100vh", overflow: "auto" }}>
      <div className="modal-content-screen1" style={{ overflow: "visible" }}>
        <div className="row sticky-topNew">
          <div className="col-12 page_heading">
            <h4 className="text-center mb-0">Add Bill</h4>
            <span className="close pr-2" onClick={onClose}>
              &times;
            </span>
          </div>
        </div>

        <div className="pl-3 pr-3">
          <div className="row">
            <div className="col-md-2 mt-md-4 text-left p-0">
              <label className="input_label m-0">Work Done %:</label>
            </div>
            <div className="col-md-3 mt-md-4 p-0 d-flex">
              <input
                type="number"
                className="input_styling ml-md-3"
                min={0}
                max={100}
                value={cumulativePercentage}
                onChange={(e) => setCumulativePercentage(e.target.value)}
                placeholder="e.g. 25"
              />
              <span className="estaric">*</span>
            </div>
            <div className="col-md-2 mt-md-4 text-left p-0"></div>

            <div className="col-md-2 mt-md-4 text-left p-0">
              <label className="input_label m-0">Image:</label>
            </div>
            <div className="col-md-3 mt-md-4 p-0">
              <input
                type="file"
                className="input_styling ml-md-3"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-2 mt-md-4 text-left p-0">
              <label className="input_label m-0">Approver Users:</label>
            </div>
            <div
              className="col-md-3 mt-md-4 p-0"
              style={{ position: "relative" }}
              ref={dropdownRef}
            >
              <div className="d-flex">
                <div
                  className="input_styling ml-md-3"
                  style={{
                    minHeight: "82px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "4px",
                    alignItems: "start",
                    cursor: "pointer",
                    padding: "8px",
                    boxSizing: "border-box",
                    overflow: "auto",
                    minWidth: 0,
                    maxHeight: "120px",
                  }}
                  onClick={() => setShowApproverDropdown((prev) => !prev)}
                >
                  {approverUserIds.length === 0 ? (
                    <span style={{ color: "#6c757d", fontSize: "14px" }}>Select approvers...</span>
                  ) : (
                    approverUserIds.map((userId) => {
                      const user = allUsers?.find((u) => u?.Id === userId);
                      return (
                        <span
                          key={userId}
                          style={{
                            backgroundColor: "#e9ecef",
                            padding: "4px 8px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            flex: "0 1 auto",
                            maxWidth: "100%",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "inline-block",
                              maxWidth: "120px",
                            }}
                          >
                            {user ? user.FullName : userId}
                          </span>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              removeApprover(userId);
                            }}
                            style={{
                              cursor: "pointer",
                              color: "#dc3545",
                              fontWeight: "bold",
                            }}
                          >
                            ×
                          </span>
                        </span>
                      );
                    })
                  )}
                </div>
                {/* <span className="estaric">*</span> */}
              </div>

              {showApproverDropdown && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    zIndex: 9999,
                    background: "#fff",
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    maxHeight: "220px",
                    overflowY: "auto",
                  }}
                >
                  <div
                    style={{
                      padding: "8px",
                      borderBottom: "1px solid #e9ecef",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Search users..."
                      value={approverSearchTerm}
                      onChange={(e) => setApproverSearchTerm(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "6px 8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        fontSize: "14px",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>

                  <div>
                    {filteredUsers?.map((user) => (
                      <div
                        key={user.Id}
                        onClick={() => toggleApprover(user.Id)}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          backgroundColor: approverUserIds.includes(user.Id)
                            ? "#e9ecef"
                            : "transparent",
                          borderBottom: "1px solid #f8f9fa",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={approverUserIds.includes(user.Id)}
                          readOnly
                          style={{ margin: 0 }}
                        />
                        <div>
                          <div style={{ fontWeight: "500", fontSize: "13px" }}>{user.FullName}</div>
                          <div style={{ fontSize: "12px", color: "#6c757d" }}>{user.Email}</div>
                        </div>
                      </div>
                    ))}
                    {filteredUsers.length === 0 && (
                      <div
                        style={{
                          padding: "12px",
                          textAlign: "center",
                          color: "#6c757d",
                        }}
                      >
                        No users found
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12 d-flex justify-content-end" style={{ gap: 8 }}>
              <ActionButton
                text="Cancel"
                variant="cancel"
                onClick={onClose}
                disabled={submitting}
              />
              <ActionButton
                text={submitting ? "Please wait..." : "Create Bill"}
                variant="save"
                onClick={handleSubmit}
                disabled={submitting}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
